import { Fab } from "@mui/material";
import YouTubeIcon from "@mui/icons-material/YouTube";
import XIcon from "@mui/icons-material/X";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";

export const getSocialIcon = (platform) => {
  switch (platform) {
    case "YOUTUBE":
      return (
        <Fab
          size="small"
          aria-label="YouTube"
          sx={{
            width: 36,
            height: 36,
            color: "common.white",
            bgcolor: "#FF0000",
            "&:hover": {
              bgcolor: "#FF0000",
            },
          }}
        >
          <YouTubeIcon />
        </Fab>
      );
    case "X":
      return (
        <Fab
          size="small"
          aria-label="Twitter"
          sx={{
            width: 36,
            height: 36,
            color: "common.white",
            bgcolor: "#2196f3",
            "&:hover": {
              bgcolor: "#2196f3",
            },
          }}
        >
          <XIcon />
        </Fab>
      );
    case "LINKEDIN":
      return (
        <Fab
          size="small"
          aria-label="LinkedIn"
          sx={{
            width: 36,
            height: 36,
            color: "common.white",
            bgcolor: "#2196f3",

            "&:hover": {
              bgcolor: "#2196f3",
            },
          }}
        >
          <LinkedInIcon />
        </Fab>
      );
    case "INSTAGRAM":
      return (
        <Fab
          size="small"
          aria-label="Instagram"
          sx={{
            width: 36,
            height: 36,
            color: "common.white",
            bgcolor: "#e91e63",

            "&:hover": {
              bgcolor: "#e91e63",
            },
          }}
        >
          <InstagramIcon />
        </Fab>
      );
    default:
      return null;
  }
};
